import { styled } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  display: 'block',
  minHeight: '60px',
  '.ori-icon::before': {
    bottom: theme.spacing(-11),
    position: 'absolute',
    right: '1px',
    [theme.breakpoints.up('sm')]: {
      lineHeight: theme.typography.pxToRem(50),
      position: 'static',
    },
  },
}));

export const IconWrap = styled('div')(({ theme }) => ({
  color: theme.palette.primary.main,
  display: 'flex',
  fontSize: theme.typography.pxToRem(58),
  justifyContent: 'center',
  marginBottom: theme.spacing(6),
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(73),
  },
}));

export const Header = styled('h2')(({ theme }) => ({
  color: theme.palette.text.primary,
  display: 'flex',
  fontSize: theme.typography.pxToRem(20),
  justifyContent: 'center',
  lineHeight: theme.typography.pxToRem(20),
  marginBottom: theme.spacing(3),
}));

export const TextInfo = styled('p')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.pxToRem(14),
  lineHeight: theme.typography.pxToRem(19),
  margin: 0,
  paddingBottom: theme.spacing(1),
  textAlign: 'center',
}));
